import { useState } from 'react'
import { useTravelSearchContext } from '../../context/TravelSearchProvider'
import OverlayFooter from '../Shared/OverlayFooter'
import Categories from './Categories'
import Selector from './Selector'
interface Props {
  isLoading: boolean
  dataAttrList: { name: string; value: string }[]
  onFooterClick: () => void
  onCheckMultipleVehicle: (checked: boolean) => void
}
const Vehicles: React.FC<Props> = ({ isLoading, dataAttrList, onFooterClick, onCheckMultipleVehicle }) => {
  const [selectedCategory, setSelectedCategory] = useState<string | undefined>()
  const { dispatch } = useTravelSearchContext()

  const dataAttrProps = {} as {
    dataAttrName: string
    dataAttrValue: string
  }
  dataAttrList.map((dataAttr) => {
    const key = `data-e2e-${dataAttr?.name}`
    const dataAttrKey = key as keyof {
      dataAttrName: string
      dataAttrValue: string
    }
    dataAttrProps[dataAttrKey] = dataAttr.value?.toString() ?? ''
  })
  const keyLoading = `data-e2e-vehicle-loading`
  const dataAttrKeyLoading = keyLoading as keyof {
    dataAttrName: string
    dataAttrValue: string
  }
  dataAttrProps[dataAttrKeyLoading] = isLoading.toString()

  function onSelectCategory(categoryCode: string | undefined) {
    if (categoryCode === 'NCAR') {
      dispatch({
        type: 'SET_VEHICLE',
        vehicle: {
          code: 'NCAR',
          trailer: undefined,
          categoryCode: undefined,
          count: 0,
        },
      })
      dispatch({
        type: 'SET_MULTIPLE_VEHICLES_SUPPORTED',
        supported: false,
      })
      dispatch({
        type: 'SET_MULTIPLE_VEHICLES_CHECKED',
        checked: false,
      })
    } else setSelectedCategory(categoryCode)
  }

  return (
    <div className={`lg:ts-max-h-[calc(100dvh-160px)] lg:ts-min-w-[512px] lg:ts-overflow-auto`}>
      <Categories onSelectCategory={onSelectCategory} selectedCategoryCode={selectedCategory} />
      <Selector
        selectedCategoryCode={selectedCategory}
        onSelectCategory={onSelectCategory}
        onCheckMultipleVehicle={onCheckMultipleVehicle}
      />
      <OverlayFooter onClick={onFooterClick} />
    </div>
  )
}

export default Vehicles
